/* eslint-disable */
import { React, useEffect, useState } from "react";
import "./styles.scss";
import { useTranslation } from "react-i18next";
import { FaMapMarkerAlt, FaEnvelope, FaPhone } from "react-icons/fa";
import axios from "../../api/axiosService";
import FadeInSection from "../../Components/FadeInSection";
import { getLocalized } from "../../Common/Util";
import location from "../../assets/icon/iconLocation.svg";
function Contact() {
  const { t, i18n } = useTranslation();
  const [contact, setContact] = useState({});

  const getContact = async () => {
    try {
      const response = await axios.get("/api/contact/info");
      setContact(response.data.data);
    } catch (error) {
      console.error("Error fetching data: ", error);
    }
  };

  useEffect(() => {
    getContact();
  }, []);

  return (
    <div className="contact-container">
      {/* Header section */}
      <FadeInSection delay={200} direction="down">
        <div className="global-header-block-1">
          <div className="contact-title normal-text">{t("ABOUT_SSL")}</div>
          <h1 className="contact-title global-title-margin title-1">
            {" "}
            {t("CONTACT")}
          </h1>
        </div>
        {/* Logo section */}
        <div className="logo-section">
          <div className="logo-container">
            <div className="logo">
              {/* Logo is a stylized "SS" where one S is teal, one is gray */}
              <img
                style={{ width: "25%" }}
                className="logo-img"
                src="https://spacespeaker.s3.ap-southeast-1.amazonaws.com/uploads/SPACESPEAKERS_Logo-1741878492422.png"
              />
            </div>
          </div>
        </div>
      </FadeInSection>

      {/* Contact information grid */}
      <FadeInSection>
        <div className="contact-grid">
          {/* Address column */}
          <div className="contact-column">
            <div className="icon-container">
              <FaMapMarkerAlt
                style={{
                  color: "white",
                  pointerEvents: "cursor",
                  fontSize: "26px",
                  margin: "0 7px 0 7px",
                }}
              />
              {/* Font Awesome map marker icon */}
            </div>
            <div className="contact-text normal-text-1">
              <p>{getLocalized(contact, "location", i18n.language)}</p>
            </div>
          </div>
          {/* Email column */}
          <div className="contact-column">
            <div className="icon-container">
              <FaEnvelope
                style={{
                  color: "white",
                  pointerEvents: "cursor",
                  fontSize: "26px",
                  margin: "0 7px 0 7px",
                }}
              />
              {/* Font Awesome envelope icon */}
            </div>
            <div className="contact-text normal-text-1">
              <p>{contact.mailHr}</p>
              <p>{contact.mailCompany}</p>
              <p>{contact.mailArtirst}</p>
            </div>
          </div>
          <div className="contact-column phone-footer">
            <div className="phone-container">
              <FaPhone
                className="phone-icon"
                style={{
                  color: "white",
                  pointerEvents: "cursor",
                  marginBottom: "0px",
                }}
              />
              {/* Font Awesome phone icon */}
              <span className="phone-number normal-text-1">
                {contact.mobile}
              </span>
            </div>
          </div>
        </div>
      </FadeInSection>
    </div>
  );
}

export default Contact;
